(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var phrases = [
    'Search tennis chains…',
    'Search bracelets…',
    'Search rings…',
    'Search earrings…',
    'Search pendants…'
  ];

  var timers = new WeakMap();

  function cycle(input) {
    var i = 0;
    input.placeholder = phrases[0];
    var id = setInterval(function () {
      if (document.activeElement === input || input.value) return;
      i = (i + 1) % phrases.length;
      input.placeholder = phrases[i];
    }, 2200);
    timers.set(input, id);
  }

  function init() {
    document.querySelectorAll('.search-modal .search__input.field__input').forEach(function (input) {
      if (timers.has(input)) return;
      cycle(input);
      input.addEventListener('focus', function () {
        input.placeholder = 'Search';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function () {
    setTimeout(init, 50);
  });
})();
